<template>
  <div class="tbe-accordion">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "tbeAccordion",

  props: {
    value: {
      type: [Number, String],
      default: () => null
    }
  },

  data() {
    return {
      accordion: {
        active: this.value
      }
    };
  },

  provide() {
    return { accordion: this.accordion };
  }
}
</script>

<style lang="scss" scoped>
.accordion {}
</style>
